import 'containers/DetailBar/PatientBar/components/PatientProfile/RichContainer/styles.css';

type RichContainerProps = JSX.IntrinsicElements['section'];

const RichContainer = (props: RichContainerProps) => {
  return <section id="rich-container" {...props} />;
};

export default RichContainer;
